import { LanguageSwitchProps } from '.'
import { Link } from '../Link'
import { Text } from '../Typography/Text'
import { cn } from '@lib/cn'
import { FC } from 'react'

export const LanguageSwitch: FC<LanguageSwitchProps> = ({ onClickAction }) => {
  return (
    <div className={cn('grid grid-cols-[auto_auto] items-center gap-3', 'sm:gap-4')}>
      <div>
        <Text variant="micro" as="div" className="mb-1">
          Current language is
        </Text>
        <div className="flex items-center">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADrSURBVHgB5ZOhDsIwEECvDAxqJCxBYkiQq0F3CcHzB+MTQPARJHwDHo8hJJvCrjgSzMQEBEEdgjWlTSagG2Ug4alr7/Laa3MAPwsyJdfQcS2wXBVz4HQAB/qRKIBum4NYyJBoqdgC5Hmwj9+KMkkkQxuKYVKGdVlFr5KSwCBR2NltX98oWa7cutOMoAQN0sMIoeI3E0L4ojw+mFr7lqq2pttdAmVgl+tTW7lfa/Xn8rERAQNCHnjaTPDjXr61tDKShcwgYShFQ30/JzqG41gWYnVqgSZUOVWjZ4wj4pCZa9WyEblxeg6nFP6PO/+FdHZB17DaAAAAAElFTkSuQmCC"
            alt=""
            style={{ marginLeft: '-0.25rem' }}
          />
          <Text variant="regular" as="span" className="mb-0 ml-1 font-bold">
            Dutch
          </Text>
        </div>
      </div>
      <div className="flex justify-end">
        <Link variant="blue" onClick={onClickAction}>
          Switch to English
        </Link>
      </div>
    </div>
  )
}
